import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import "antd/es/button/style";
import _Button from "antd/es/button";
import "antd/es/tooltip/style";
import _Tooltip from "antd/es/tooltip";
var _excluded = ["creatorButtonProps", "deleteIconProps", "copyIconProps", "itemContainerRender", "itemRender", "prefixCls", "creatorRecord", "action", "children", "actionRender", "fields", "meta", "field", "index", "formInstance"],
    _excluded2 = ["actionRender", "creatorButtonProps", "label", "tooltip", "creatorRecord", "itemRender", "rules", "itemContainerRender", "copyIconProps", "children", "deleteIconProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useRef, useMemo } from 'react';
import omit from 'omit.js';
import toArray from "rc-util/es/Children/toArray";
import { DeleteOutlined, PlusOutlined, CopyOutlined } from '@ant-design/icons';
import './index.less';
import get from "rc-util/es/utils/get";
import { runFunction } from '@ant-design/pro-utils';
var FormListContext = /*#__PURE__*/React.createContext({});
/** Antd 自带的toArray 不这次方法，所以需要自己搞一个 */

var listToArray = function listToArray(children) {
  if (Array.isArray(children)) {
    return children;
  }

  return toArray(children);
};

var ProFormListItem = function ProFormListItem(props) {
  var _formInstance$getFiel;

  var creatorButtonProps = props.creatorButtonProps,
      deleteIconProps = props.deleteIconProps,
      copyIconProps = props.copyIconProps,
      itemContainerRender = props.itemContainerRender,
      itemRender = props.itemRender,
      prefixCls = props.prefixCls,
      creatorRecord = props.creatorRecord,
      action = props.action,
      children = props.children,
      actionRender = props.actionRender,
      fields = props.fields,
      meta = props.meta,
      field = props.field,
      index = props.index,
      formInstance = props.formInstance,
      rest = _objectWithoutProperties(props, _excluded);

  var listContext = useContext(FormListContext);
  var childrenArray = listToArray(children).map(function (childrenItem) {
    if (typeof childrenItem === 'function') {
      return childrenItem === null || childrenItem === void 0 ? void 0 : childrenItem(field, index);
    }

    return childrenItem;
  }).map(function (childrenItem, childIndex) {
    if ( /*#__PURE__*/React.isValidElement(childrenItem)) {
      return /*#__PURE__*/React.cloneElement(childrenItem, _objectSpread({
        key: childIndex
      }, childrenItem === null || childrenItem === void 0 ? void 0 : childrenItem.props));
    }

    return childrenItem;
  });
  var copyIcon = useMemo(function () {
    /** 复制按钮的配置 */
    if (!copyIconProps) return null;
    var _copyIconProps$Icon = copyIconProps.Icon,
        Icon = _copyIconProps$Icon === void 0 ? CopyOutlined : _copyIconProps$Icon,
        tooltipText = copyIconProps.tooltipText;
    return /*#__PURE__*/React.createElement(_Tooltip, {
      title: tooltipText,
      key: "copy"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixCls, "-action-icon"),
      onClick: function onClick() {
        action.add(formInstance === null || formInstance === void 0 ? void 0 : formInstance.getFieldValue([listContext.listName, rest.name, field.name].filter(function (item) {
          return item !== undefined;
        }).flat(1)));
      }
    }));
  }, [action, copyIconProps, field.name, formInstance, listContext.listName, prefixCls, rest.name]);
  var deleteIcon = useMemo(function () {
    if (!deleteIconProps) return null;
    var _deleteIconProps$Icon = deleteIconProps.Icon,
        Icon = _deleteIconProps$Icon === void 0 ? DeleteOutlined : _deleteIconProps$Icon,
        tooltipText = deleteIconProps.tooltipText;
    return /*#__PURE__*/React.createElement(_Tooltip, {
      title: tooltipText,
      key: "delete"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixCls, "-action-icon"),
      onClick: function onClick() {
        return action.remove(field.name);
      }
    }));
  }, [action, deleteIconProps, field.name, prefixCls]);
  var defaultActionDom = useMemo(function () {
    return [copyIcon, deleteIcon].filter(Boolean);
  }, [copyIcon, deleteIcon]);
  var actions = (actionRender === null || actionRender === void 0 ? void 0 : actionRender(field, action, defaultActionDom)) || defaultActionDom;
  var dom = actions.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-action")
  }, actions) : null;
  var options = {
    field: field,
    index: index,
    record: formInstance === null || formInstance === void 0 ? void 0 : (_formInstance$getFiel = formInstance.getFieldValue) === null || _formInstance$getFiel === void 0 ? void 0 : _formInstance$getFiel.call(formInstance, [listContext.listName, rest.name, field.name].filter(function (item) {
      return item !== undefined;
    }).flat(1)),
    fields: fields,
    operation: action,
    meta: meta
  };
  var itemContainer = (itemContainerRender === null || itemContainerRender === void 0 ? void 0 : itemContainerRender(childrenArray, options)) || childrenArray;
  var contentDom = (itemRender === null || itemRender === void 0 ? void 0 : itemRender({
    listDom: /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-container")
    }, itemContainer),
    action: dom
  }, options)) || /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item"),
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, itemContainer), dom);
  return /*#__PURE__*/React.createElement(FormListContext.Provider, {
    key: field.name,
    value: _objectSpread(_objectSpread({}, field), {}, {
      listName: [listContext.listName, rest.name, field.name].filter(function (item) {
        return item !== undefined;
      }).flat(1)
    })
  }, contentDom);
};

var ProFormListContainer = function ProFormListContainer(props) {
  var creatorButtonProps = props.creatorButtonProps,
      prefixCls = props.prefixCls,
      children = props.children,
      creatorRecord = props.creatorRecord,
      action = props.action,
      fields = props.fields;
  var creatorButton = useMemo(function () {
    if (creatorButtonProps === false) return null;

    var _ref = creatorButtonProps || {},
        _ref$position = _ref.position,
        position = _ref$position === void 0 ? 'bottom' : _ref$position,
        _ref$creatorButtonTex = _ref.creatorButtonText,
        creatorButtonText = _ref$creatorButtonTex === void 0 ? '添加一行数据' : _ref$creatorButtonTex;

    return /*#__PURE__*/React.createElement(_Button, _extends({
      className: "".concat(prefixCls, "-creator-button-").concat(position),
      type: "dashed",
      block: true,
      icon: /*#__PURE__*/React.createElement(PlusOutlined, null)
    }, omit(creatorButtonProps || {}, ['position', 'creatorButtonText']), {
      onClick: function onClick() {
        var index; // 如果是顶部，加到第一个，如果不是，为空就是最后一个

        if (position === 'top') index = 0;
        action.add(runFunction(creatorRecord), index);
      }
    }), creatorButtonText);
  }, [action, creatorButtonProps, creatorRecord, prefixCls]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: 'max-content',
      maxWidth: '100%'
    }
  }, creatorButtonProps !== false && (creatorButtonProps === null || creatorButtonProps === void 0 ? void 0 : creatorButtonProps.position) === 'top' && creatorButton, fields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(ProFormListItem, _extends({
      key: field.name.toString()
    }, props, {
      field: field,
      index: index
    }), children);
  }), creatorButtonProps !== false && (creatorButtonProps === null || creatorButtonProps === void 0 ? void 0 : creatorButtonProps.position) !== 'top' && creatorButton);
};

var ProFormList = function ProFormList(_ref2) {
  var actionRender = _ref2.actionRender,
      creatorButtonProps = _ref2.creatorButtonProps,
      label = _ref2.label,
      tooltip = _ref2.tooltip,
      creatorRecord = _ref2.creatorRecord,
      itemRender = _ref2.itemRender,
      rules = _ref2.rules,
      itemContainerRender = _ref2.itemContainerRender,
      _ref2$copyIconProps = _ref2.copyIconProps,
      copyIconProps = _ref2$copyIconProps === void 0 ? {
    Icon: CopyOutlined,
    tooltipText: '复制此行'
  } : _ref2$copyIconProps,
      children = _ref2.children,
      _ref2$deleteIconProps = _ref2.deleteIconProps,
      deleteIconProps = _ref2$deleteIconProps === void 0 ? {
    Icon: DeleteOutlined,
    tooltipText: '删除此行'
  } : _ref2$deleteIconProps,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var actionRef = useRef();
  var context = useContext(_ConfigProvider.ConfigContext);
  var listContext = useContext(FormListContext);
  var baseClassName = context.getPrefixCls('pro-form-list'); // 处理 list 的嵌套

  var name = useMemo(function () {
    if (listContext.name === undefined) {
      return [rest.name].flat(1);
    }

    return [listContext.name, rest.name].flat(1);
  }, [listContext.name, rest.name]);
  return /*#__PURE__*/React.createElement(_Form.Item, {
    label: label,
    tooltip: tooltip,
    rules: rules,
    shouldUpdate: function shouldUpdate(prevValues, nextValues) {
      return get(prevValues, name) !== get(nextValues, name);
    }
  }, function (formInstance) {
    return /*#__PURE__*/React.createElement("div", {
      className: baseClassName
    }, /*#__PURE__*/React.createElement(_Form.List, _extends({
      rules: rules
    }, rest, {
      name: name
    }), function (fields, action, meta) {
      if (typeof children === 'function') {
        return children(fields, action, meta);
      } // 将 action 暴露给外部


      actionRef.current = action;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProFormListContainer, {
        name: name,
        copyIconProps: copyIconProps,
        deleteIconProps: deleteIconProps,
        formInstance: formInstance,
        prefixCls: baseClassName,
        meta: meta,
        fields: fields,
        itemContainerRender: itemContainerRender,
        itemRender: itemRender,
        creatorButtonProps: creatorButtonProps,
        creatorRecord: creatorRecord,
        actionRender: actionRender,
        action: action
      }, children), /*#__PURE__*/React.createElement(_Form.ErrorList, {
        errors: meta.errors
      }));
    }));
  });
};

export { FormListContext };
export default ProFormList;